
export default [
  {
    path: '/learning-modules/:learningModuleId/start',
    name: 'learningModules#start',
    component: () => import(/* webpackChunkName: "learningModules/start" */ '@views/learningModules/start'),
    meta: {
      header: true,
      masteryFooter: true,
      masteryHeader: true,
    },
  },
  {
    path: '/learning-modules/:learningModuleId/complete',
    name: 'learningModules#complete',
    component: () => import(/* webpackChunkName: "learningModules/complete" */ '@views/learningModules/complete'),
    meta: {
      header: true,
      masteryFooter: true,
      masteryHeader: true,
    },
  },
  {
    path: '/learning-modules/:learningModuleId/section/:sectionId/start',
    name: 'learningModules#section#start',
    component: () => import(/* webpackChunkName: "learningModules/section/start" */ '@views/learningModules/section/start'),
    meta: {
      header: true,
      masteryFooter: true,
      masteryHeader: true,
    },
  },
  {
    path: '/learning-modules/:learningModuleId/section/:sectionId/complete',
    name: 'learningModules#section#complete',
    component: () => import(/* webpackChunkName: "learningModules/section/complete" */ '@views/learningModules/section/complete'),
    meta: {
      header: true,
      masteryFooter: true,
      masteryHeader: true,
    },
  },
  {
    path: '/learning-modules/:learningModuleId/section/:sectionId/:assetAssociationId?',
    name: 'learningModules#section#show',
    component: () => import(/* webpackChunkName: "learningModules/section/show" */ '@views/learningModules/section/show'),
    meta: {
      header: true,
      masteryFooter: true,
      masteryHeader: true,
    },
  },
  {
    path: '/learning-modules',
    name: 'learningModules#index',
    component: () => import(/* webpackChunkName: "learningModules/index" */ '@views/learningModules/index'),
    meta: {
      header: true,
    },
  },
];